// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PCameraOutlinedSvg from "@fishx/icons-svg/es/asn/PCameraOutlined";
import FishxIcon from '../components/FishxIcon';

var PCameraOutlined = function PCameraOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PCameraOutlinedSvg
  }));
};

PCameraOutlined.displayName = 'PCameraOutlined';
export default React.forwardRef(PCameraOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PCameraOutlined.js
// module id = 3268
// module chunks = 0